import { render, staticRenderFns } from "./RateSettingList.vue?vue&type=template&id=f95a7dbc&scoped=true"
import script from "./RateSettingList.vue?vue&type=script&lang=js"
export * from "./RateSettingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95a7dbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f95a7dbc')) {
      api.createRecord('f95a7dbc', component.options)
    } else {
      api.reload('f95a7dbc', component.options)
    }
    module.hot.accept("./RateSettingList.vue?vue&type=template&id=f95a7dbc&scoped=true", function () {
      api.rerender('f95a7dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/systemSet/RateSettingList.vue"
export default component.exports